import {ContentTypeEnum} from "../builder/domain/ContentTypeEnum";

export class ContentData {

    constructor(
        readonly type:ContentTypeEnum,
        readonly lazy:boolean = true,
        readonly url?:URL,
        readonly content?:string
    ){}
}